(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('QueueStatusDeleteController',QueueStatusDeleteController);

    QueueStatusDeleteController.$inject = ['$uibModalInstance', 'entity', 'QueueStatus'];

    function QueueStatusDeleteController($uibModalInstance, entity, QueueStatus) {
        var vm = this;

        vm.queueStatus = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            QueueStatus.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
